import { runWhenIdle } from '../../../lib/browserSurface';
interface Replay { start: () => void; stop: () => void }
let replay: Replay | null = null;
let active = 0;
const pending = new Set<() => void>();

export function bindArenaReplay(client: Replay): void {
  replay = client;
  if (active > 0) client.stop(); else client.start();
}

export function pauseArenaReplay(): () => void {
  if (active++ === 0) replay?.stop();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--active === 0) { replay?.start(); for (const schedule of pending) schedule(); }
  };
}

export function runWhenArenaIdle(run: () => void): () => void {
  let scheduled = false;
  let cancel = () => {};
  const schedule = () => {
    if (active > 0 || scheduled) return;
    scheduled = true;
    cancel = runWhenIdle(() => {
      scheduled = false;
      if (active > 0) return;
      pending.delete(schedule);
      run();
    }, { fallbackDelayMs: 1500 });
  };
  // WHY: tracking stubs keep accepting events while expensive vendor evaluation waits until combat has ended.
  pending.add(schedule); schedule();
  return () => { pending.delete(schedule); cancel(); };
}
